export default {
  GENERAL: 'general',
  DESCRIPTION: 'description',
  LOGO: 'logo',
  CONTACTS: 'contacts',
  SOCIALS: 'socials',
  SUMMARY: 'summary',
};
